import React from 'react';

export default () => (
    <hr style={{margin: '0.5rem 2rem', borderColor: 'var(--secondary-accent-color)'}}/>
);